export type TrackingPhaseId = 'order-processing' | 'international-shipping' | 'final-delivery' | 'delivered';

export const PHASE_ORDER: TrackingPhaseId[] = [
  'order-processing',
  'international-shipping',
  'final-delivery',
  'delivered',
];

export const EVENT_TYPE_TO_PHASE: Record<string, TrackingPhaseId> = {
  // Unified tracking — Order Processing
  ORDER_CREATED: 'order-processing',
  ORDER_PLACED: 'order-processing',
  PICKED_UP: 'order-processing',
  COLLECTED_AT_TERMINAL: 'order-processing',
  ARRIVED_AT_ORIGIN_FACILITY: 'order-processing',
  DEPARTED_FROM_ORIGIN_FACILITY: 'order-processing',
  ARRIVED_AT_ORIGIN_AIRPORT: 'order-processing',
  EXPORT_CUSTOMS_ENTRY: 'order-processing',
  EXPORT_CUSTOMS_CLEARED: 'order-processing',

  // Unified tracking — International Shipping
  DEPARTED_FROM_ORIGIN: 'international-shipping',
  ARRIVED_AT_TRANSIT: 'international-shipping',
  DEPARTED_FROM_TRANSIT: 'international-shipping',
  ARRIVED_AT_DESTINATION: 'international-shipping',
  IN_TRANSIT: 'international-shipping',
  CUSTOMS_ENTRY: 'international-shipping',
  CUSTOMS_INSPECTION: 'international-shipping',
  CUSTOMS_HELD: 'international-shipping',
  CUSTOMS_CLEARED: 'international-shipping',
  CUSTOMS_CLEARANCE: 'international-shipping',
  CUSTOMS_HOLD: 'international-shipping',
  TRACKING_NUMBER_CHANGED: 'international-shipping',
  RELABELLED: 'international-shipping',
  DELAY_REPORTED: 'international-shipping',

  // Unified tracking — Final Delivery
  HANDED_TO_LOCAL_CARRIER: 'final-delivery',
  ARRIVED_AT_SORTING_HUB: 'final-delivery',
  DEPARTED_FROM_SORTING_HUB: 'final-delivery',
  ARRIVED_AT_DELIVERY_FACILITY: 'final-delivery',
  LOCAL_IN_TRANSIT: 'final-delivery',
  OUT_FOR_DELIVERY: 'final-delivery',
  AWAITING_COLLECTION: 'final-delivery',
  DELIVERY_ATTEMPTED: 'final-delivery',
  FAILED_ATTEMPT: 'final-delivery',
  DELIVERY_FAILED_ADDRESS: 'final-delivery',
  DELIVERY_FAILED_NOT_HOME: 'final-delivery',
  DELIVERY_FAILED_REFUSED: 'final-delivery',
  DELIVERY_FAILED_OTHER: 'final-delivery',
  PACKAGE_DAMAGED: 'final-delivery',
  PACKAGE_LOST: 'final-delivery',
  RETURNING_TO_SENDER: 'final-delivery',
  RETURNED_TO_SENDER: 'final-delivery',
  CANCELLED: 'final-delivery',
  EXPIRED: 'final-delivery',

  // Unified tracking — Delivered
  DELIVERED: 'delivered',
  DELIVERED_TO_DOOR: 'delivered',
  DELIVERED_SIGNED: 'delivered',

  // Deleo
  I00: 'order-processing',
  I01: 'international-shipping',
  I02: 'final-delivery',
  I03: 'international-shipping',
  I04: 'international-shipping',
  D06: 'delivered',

  // YunExpress
  ORDER_CREATION: 'order-processing',
  PRE_INFO: 'order-processing',
  PRE_ADVICING: 'order-processing',
  FIRST_MILE_ARRIVE: 'order-processing',
  FIRST_MILE_DEPART: 'international-shipping',
  DEPART_CONFIRM_OC: 'international-shipping',
  ARRIVE_CONFIRM_OC: 'international-shipping',
  MAIN_LINE_DEPART: 'international-shipping',
  MAIN_LINE_ARRIVE: 'international-shipping',
  TRANSIT_IN: 'international-shipping',
  TRANSIT_OUT: 'international-shipping',
  TRANSITHUB_ARRIVE: 'international-shipping',
  ARRIVE_ORIN_CUSTOMS: 'international-shipping',
  CUSTOMS_PROCESSING: 'international-shipping',
  CUSTOMS_COMPLETE: 'international-shipping',
  CUSTOMS_RELEASE: 'final-delivery',
  EXPORT_CUSTOMS_COMPLETE: 'international-shipping',
  AIRPORT_RELEASE: 'international-shipping',
  CARRIER_PICKUP: 'final-delivery',
  IN_TRANSIT_CARRIER: 'final-delivery',
  DELIVERY_ATTEMPT: 'final-delivery',

  // PARXL
  Booked: 'order-processing',
  'Booking received': 'order-processing',
  'Picked up': 'order-processing',
  'Received at parxl export hub': 'order-processing',
  'Processing at parxl export hub': 'order-processing',
  'Ready to transfer to airline': 'international-shipping',
  'Received at airline terminal': 'international-shipping',
  'Departed from origin airport': 'international-shipping',
  'In transit': 'international-shipping',
  'Arrived at destination airport': 'final-delivery',
  'Arrived at destination customs facility': 'final-delivery',
  'Enroute to destination sorting hub': 'final-delivery',
  'Arrived and processed at sorting hub': 'final-delivery',
  'Arrived and processing at sorting hub': 'final-delivery',
  'Handed over for customs clearance': 'final-delivery',
  'Custom cleared at destination': 'final-delivery',
  'Out for delivery': 'final-delivery',
  'Awaiting collection': 'final-delivery',
  Delivered: 'delivered',
};

export const UNIFIED_STATUS_TO_PHASE: Record<string, TrackingPhaseId> = {
  ORDER_PLACED: 'order-processing',
  PICKED_UP: 'order-processing',
  IN_TRANSIT: 'international-shipping',
  CUSTOMS_CLEARANCE: 'international-shipping',
  CUSTOMS_HOLD: 'international-shipping',
  ARRIVED_AT_DESTINATION: 'international-shipping',
  HANDED_TO_LOCAL_CARRIER: 'final-delivery',
  LOCAL_IN_TRANSIT: 'final-delivery',
  OUT_FOR_DELIVERY: 'final-delivery',
  FAILED_ATTEMPT: 'final-delivery',
  EXCEPTION: 'final-delivery',
  RETURNING: 'final-delivery',
  RETURNED: 'final-delivery',
  LOST: 'final-delivery',
  CANCELLED: 'final-delivery',
  EXPIRED: 'final-delivery',
  DELIVERED: 'delivered',
};
